import React from "react";

export const getMatchOrLeagueUrl = ({ dataType, dataId, sport, baseUrl, date, type }) => {
    const mapping = {
        // HEADS

        "match": `/match/${dataId}/detail`,
        "league": `/league/${dataId}/header`,
        // I have handled Team Head in ./teamHandler because it requires LeagueId API.
        // I have handled Player Head in ./playerHandler because it requires LeagueId API.

        //LIVE CENTRE

        "live-centre": `${sport === 'golf' ? `/matches?match_type=${type}&date=${date}` : `/${sport === 'football' ? "new-matches" : "matches"}?type=${type}&date=${date}`}`,
        "live-match-detail": `${sport === 'golf' ? `/matches?match_type=${type}&date=${date}` : `/${sport === 'football' ? "new-matches" : "matches"}?type=${type}&date=${date}`}`,
        "horse-racing-live": `/meetings?date=${date}`,
        "football-live-centre": `/new-matches?type=${type}&date=${date}`,
        "rugby-live-centre": `/matches?type=${type}&date=${date}`,
        "basketball-live-centre": `/matches?type=${type}&date=${date}`,
        "tennis-live-centre": `/matches?type=${type}&date=${date}`,
        "icehockey-live-centre": `/matches?type=${type}&date=${date}`,
        "golf-live-centre": `/matches?match_type=${type}&date=${date}`,
        "horseracing-live-centre": `/meetings?date=${date}`,

        //FOOTBALL

        "match-table": `/match/${dataId}/table?type=3`,
        "match-h2h": `/match/${dataId}/h2h`,
        "match-stats": `/match/${dataId}/stat`,
        "match-lineup": `/match/${dataId}/lineup`,
        "match-info": `/match/${dataId}/summary`,
        "match-summary": `/match/${dataId}/summary`,
        "match-timeline": `/match/${dataId}/summary`,
        "match-editorial": `/match/${dataId}/summary`, // EditorialHeader events (pair with head=match)
        "match-page": `/match/${dataId}/summary`,
        "match-com": `/match/${dataId}/commentary`,
        "match-news": `/match/${dataId}/news`,
        "league-standings": `/league/${dataId}/table`,
        "league-table": `/league/${dataId}/table`,
        "detailed-league-table": `/league/${dataId}/table?type=list`,
        "preview-league-table": `/league/${dataId}/table?type=list`,
        "league-top-scorers": `/league/${dataId}/top-scorers`,
        "league-info": `/league/${dataId}/info?groupBy=true`,
        "league-upcoming": `/league/${dataId}/matches?match_type=upcoming&groupBy=true`,
        "league-results": `/league/${dataId}/matches?match_type=finished&groupBy=true`,
        "league-finished": `/league/${dataId}/matches?match_type=finished&groupBy=true`,
        "league-news": `/league/${dataId}/news`,
        "league-teams": `/league/${dataId}}/teams`,

        // Cricket

        "cricket-match-info": `/match/${dataId}/info`,
        "cricket-match-live": `/match/${dataId}/live`,
        "cricket-match-standings": `/match/${dataId}/standings`,
        "cricket-match-scorecard": `/match/${dataId}/scorecard`,
        "cricket-match-wickets": `/match/${dataId}/fall-of-wickets`,
        "cricket-match-teams": `/match/${dataId}/teams`,
        "cricket-match-com": `/match/${dataId}/innings`,
        "cricket-league-info": `/league/${dataId}/info`,
        "cricket-league-upcoming": `/league/${dataId}/matches?match_type=upcoming`,
        "cricket-league-results": `/league/${dataId}/matches?match_type=finished`,
        "cricket-league-standings": `/league/${dataId}/table`,
        "cricket-team-info": `/team/${dataId}/info`,
        "cricket-team-upcoming": `/team/${dataId}/matches?match_type=upcoming`,
        "cricket-team-results": `/team/${dataId}/matches?match_type=finished`,



        //TENNIS

        "tennis-match": `/match/${dataId}/detail`,
        "tennis-match-info": `/match/${dataId}/commentary`,
        "tennis-match-stats": `/match/${dataId}/stat`,
        "tennis-rankings": `/rankings`,
        "tennis-league-info": `/league/${dataId}/info`,
        "tennis-league-upcoming": `/league/${dataId}/matches?type=upcoming`,
        "tennis-league-results": `/league/${dataId}/matches?type=finished`,
        "tennis-player-info": `/player/${dataId}/info`,
        "tennis-player-upcoming": `/player/${dataId}/matches?type=upcoming`,
        "tennis-player-results": `/player/${dataId}/matches?type=finished`,

        //BASKETBALL

        "basketball-match": `/match/${dataId}/detail`,
        "basketball-match-info": `/match/${dataId}/info`,
        "basketball-match-stats": `/match/${dataId}/stat`,
        "basketball-match-lineup": `/match/${dataId}/lineup`,
        "basketball-match-h2h": `/match/${dataId}/h2h`,
        "basketball-match-table": `/match/${dataId}/table`,
        "basketball-match-scoring": `/match/${dataId}/scoring`,
        "basketball-team-info": `/team/${dataId}/info`,
        "basketball-team-upcoming": `/team/${dataId}/matches?type=upcoming`,
        "basketball-team-results": `/team/${dataId}/matches?type=finished`,
        "basketball-league-info": `/league/${dataId}/info`,
        "basketball-league-upcoming": `/league/${dataId}/matches?type=upcoming`,
        "basketball-league-results": `/league/${dataId}/matches?type=finished`,
        "basketball-league-standings": `/league/${dataId}/table`,

        //RUGBY 

        "rugby-match": `/match/${dataId}/detail`,
        "rugby-match-detail": `/match/${dataId}/detail`,
        "rugby-match-info": `/match/${dataId}}/info`,
        "rugby-match-lineup": `/match/${dataId}}/lineup`,
        "rugby-match-standings": `/match/${dataId}}/table`,
        "rugby-league-info": `/league/${dataId}/info`,
        "rugby-league-upcoming": `/league/${dataId}/matches?match_type=upcoming`,
        "rugby-league-results": `/league/${dataId}/matches?match_type=finished`,
        "rugby-league-standings": `/league/${dataId}/table`,
        "rugby-team-info": `/team/${dataId}/info`,
        "rugby-team-upcoming": `/team/${dataId}/matches?matches=upcoming`,
        "rugby-team-results": `/team/${dataId}/matches?matches=finished`,
        "rugby-team-standings": `/team/${dataId}/table`,


        //GOLF
        "golf-league-info": `/league/${dataId}/summary`,
        "golf-league-news": `/news/league/${dataId}?page=1&limit=10`,
        "golf-player-card": `/match/${dataId}/summary`,

        //FORMULA 1  (sport = formula1 → base/formula1/…)
        "f1-standings": `/driver-standings`,               // Classifica Campionato (SSR seeds drivers)
        "f1-championship-standings": `/driver-standings`,
        "f1-driver-standings": `/driver-standings`,
        "f1-team-standings": `/team-standings`,
        "f1-races": `/races`,
        "f1-race-calendar": `/races`,
        "f1-race-hero": `/races`, // Race-day hero (picks the race by data-id from the list)
        "f1-race-results": `/${dataId}/races`, // per-race driver finishing order (podium)
        "f1-drivers": `/drivers`,
        "f1-teams": `/teams`,

        //Horse Racing
        "horse-racing-cards": `/meeting/${dataId}/runners`,

        //Ice Hockey
        "icehockey-match": `/match/${dataId}/detail`,
        "icehockey-match-info": `/match/${dataId}/summary`,
        "icehockey-match-stats": `/match/${dataId}/stats`,
        "icehockey-match-h2h": `/match/${dataId}/h2h`,
        "icehockey-match-table": `/match/${dataId}/standing`,
        "icehockey-league-info": `/league/${dataId}/info`,
        "icehockey-league-upcoming": `/league/${dataId}/matches?type=upcoming`,
        "icehockey-league-results": `/league/${dataId}/matches?type=finished`,
        "icehockey-league-standings": `/league/${dataId}/table`,
        "icehockey-team-info": `/team/${dataId}/info`,
        "icehockey-team-upcoming": `/team/${dataId}/matches?type=upcoming`,
        "icehockey-team-results": `/team/${dataId}/matches?type=finished`,
    };

    const path = mapping[dataType];
    return path ? `${baseUrl}/${sport}${path}` : null;
};
